export default __webpack_public_path__ + "static/nursing_carousel_5-c515d9c62f86ff0be14dc185490d57e0.jpg";